<template>
    <!-- Start Main Content -->
    <div v-show="!isBarcodePrint" class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Single Attendance Report</h2>
        </div>

  
<!-- Filter Form -->
<div class="card p-4 mb-4 header_class">
    <form @submit.prevent="filterAttendances">
        <div class="flex flex-col sm:flex-row sm:space-x-4">
            <div class="mb-4 sm:mb-0 w-full sm:w-auto">
                <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
                <input type="date" id="startDate" v-model="startDate" class="p-2 border border-gray-300 rounded w-full sm:w-auto" />
            </div>
            <div class="mb-4 sm:mb-0 w-full sm:w-auto">
                <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
                <input type="date" id="endDate" v-model="endDate" class="p-2 border border-gray-300 rounded w-full sm:w-auto" />
            </div>

            <div class="mb-4 sm:mb-0 w-full sm:w-auto">
                <label for="mukkadam" class="block text-sm font-medium text-gray-700">Select Employee</label>
                <select class="form-input w-full sm:w-auto" v-model="selectedEmployeeId">
                    <option v-for="(item, index) in employeeList" :key="index" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
            </div>

            <div class="mt-3 sm:mt-0 w-full sm:w-auto ml-3">
                <button type="submit" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm" @click="filter_dates()">Filter</button>
            </div>
            
          
            
        </div>
    </form>
</div>


          <div class="w-full lg:w-auto lg:ml-2 mt-4 mb-2 ml-2">
            <button @click="exportToExcel" class="w-full lg:w-auto btn btn-primary-solid px-5 mt-2 lg:mt-6 cursor-pointer">
                Export
            </button>
        </div>


           <div class="card">
                <!-- Static heading -->
                <div id="printable-content">
                    <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>
                    <h1 class="print-only" style="text-align: center;">Salary Slip</h1>
                </div>

                <button
                    type="reset"
                    @click="printReceipt"
                    class="btn b-light btn-danger-light btn-sm"
                >
                    Print
                </button>
                </div>
     

        



        <div class="grid grid-cols-12">
            <div class="col-span-full">
                <div class="card p-0">
                   
                    <div class="p-6 space-y-4 overflow-x-auto">
                        <div style="display: flex; gap: 20px;" >
                    <h1>{{ "Name:-" + attendanceReport.empname }}</h1>
                    <h1>{{ "From:- " + formatDate(startDate) }}</h1>
                    <h1>{{ "To:- " + formatDate(endDate) }}</h1>
                    </div>
                        <table id="basicDataTable" class="datatable min-w-full bg-white divide-y divide-gray-200">
                          <thead class="bg-gray-50">  
                              <tr>
                                <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" >Date</th>
                                <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"  >Presenty</th>
                                <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" >Branch/Plot</th>
                                <th scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" >Remark</th>
                              </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                              <tr v-for="(item, index) in attendanceReport.datahere" :key="item.id">
                                
                                <td>{{ item.attendance_date }}</td>
                                <td>
                                    <div v-if="item.status=='p'">✓ P
                                          <!-- <span v-if="item.is_paid" :style="{ color: item.is_paid_color }">
                                            - {{ item.is_paid }}
                                        </span> -->
                                        </div>
                                            <div v-else>✗ A</div>
                                        </td>
                                <td>{{ item.plot_name }}</td>
                                <td class="px-6 py-4 whitespace-nowrap">{{ item.remark }}</td> 
                               </tr>
                            </tbody>

                            <tfoot>
                                
                                <tr>
                                    <td colspan="1" class="text-right">Total Days:</td>
                                    <td>{{ attendanceReport.total_day }}</td>
                                    <td></td><td></td>
                                </tr>

                                <tr>
                                    <td colspan="1" class="text-right">Total Present Days:</td>
                                    <td>{{  attendanceReport.presenty }}</td>
                                    <td></td><td></td>
                                </tr>
                                
                                <tr>
                                    <td colspan="1" class="text-right">Total Absent Days:</td>
                                    <td>{{ attendanceReport.total_day- attendanceReport.presenty }}</td>
                                    <td></td><td></td>
                                </tr>


                                <tr>
                                    <td colspan="1" class="text-right">Perday Salary:</td>
                                    <td>{{ attendanceReport.salary }}</td>
                                    <td></td><td></td>
                                </tr>

                                <tr>
                                    <td colspan="1" class="text-right">Total Salary:</td>
                                    <td>{{ attendanceReport.presenty * attendanceReport.salary }}</td>
                                    <td></td><td></td>
                                </tr>
                            </tfoot>


                          </table>
                 
                  </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
        </div>
       
    </div>
    <!-- End Main Content -->
    
    <!-- Start Delete Modal -->
   
    <!-- End Delete Modal -->
</template>
<style scoped>

    
@media print {
    button, select, input, h2, .header_class, .header, .card-title {
        display: none !important;
    }
    

}
</style>
<style scoped>
tfoot{
    background: antiquewhite;
    font-size: medium;
    font-weight: 800;
}
tfoot td{
    height: 35px;
}
.print-only {
    display: none;
}

@media print {
    .print-only {
        display: block; /* Show elements for print */
        text-align: center; /* Center alignment as needed */
        font-size: 16px; /* Font size adjustments if needed */
    }
}


@media print {
    /* Hide unnecessary elements */
    button, select, input, h2, .header_class, .header, .card-title {
        display: none !important;
    }
    

    /* Adjust the layout */
    body {
        margin: 0;
        padding: 0;
        font-family: Arial, sans-serif;
    }

    /* Receipt container */
    .receipt-container, #printable-content {
        width: 100%;
        padding: 10mm;
        margin: auto;
        border: 1px solid #000;
    }

    /* Add a border and spacing to the table */
    table {
        width: 100%;
        border-collapse: collapse;
    }

    table th, table td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
        font-size: 12px;
        color: black !important; 
    }

    
    table th {
        background-color: #f2f2f2;
        font-weight: bold;
        color: black!important;
    }

    /* Center titles */
    h1, h2 {
        text-align: center;
        margin: 0 0 10px;
        font-size: 16px;
        font-weight: bold;
    }

    /* Add company branding details */
    #printable-content {
        text-align: center;
    }

    #printable-content h1 {
        font-size: 20px;
    }

    /* Add spacing between sections */
    .section {
        margin-bottom: 20px;
    }

    /* Performance container styling */
    .performance-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .performance-box {
        flex: 1;
        padding: 5px;
        margin: 0 5px;
        border: 1px solid #ddd;
        font-size: 12px;
        text-align: center;
    }

    .performance-box.best {
        background-color: #c8e6c9;
    }

    .performance-box.good {
        background-color: #bbdefb;
    }

    .performance-box.average {
        background-color: #ffe0b2;
    }
}

  
    .salary_input{
        padding: 5px;
        width: 70px;
    }
    .plotname{
        font-size: x-small;
    font-weight: 200;
    background: yellow;
    padding: 0px 2px;
    border-radius: 10px;
    }

    .performance-container {
      display: flex;
      gap: 20px;
    }
    .performance-box {
      padding: 1px;
      border-radius: 8px;
      color: white;
      text-align: center;
      font-weight: bold;
      width: 80px;
    }
    
    .Best1 {
      background-color: green;
    }
    .Good1 {
      background-color: blue;
    }
    .Average1 {
      background-color: orange;
    }

    .best {
  color: green;
}
.good {
  color: blue;
}
.average {
  color: orange;
}
</style>
<script>
import axios from 'axios'; 

export default {
    name: 'AddProduct',
    components: { 
    },
    mounted() {
        this.getBasics(); 
    },
    data() {
        return {
          
            totalMaleCount: 0,
            totalFemaleCount: 0,
            totalovertimeCount:0,
            maleRate: 0,
            femaleRate: 0,
            overtimeRate:0,
            
            gadiBhadeRate: 0,
                    products: [
                { label: 'एकूण वाया', quantity: 88, rate: 350, amount: 0 },
                { label: 'एकूण गाडी', quantity: 13, rate: 400, amount: 0 },
            ],
            empParentList: [],
            selectedEmployeeId: null,
            filteredAttendanceList: [],
            sale: {

                employee_name:null,

            },
            total_gadibhade_amt:0,
            employeeList:[],
            startDate: new Date(),
            endDate: new Date(),
            datatable: null,
            productss: { iddate: '' },
            employees: { empname: '', emprole: '0', isMainAdmin: 0 },
            attendanceReport:{ datahere:[] },
            report_dates:[]
        }
    },
    computed: {
        
        totalPaid() {
            return this.attendanceReport.datahere.reduce((sum, item) => sum + (item.is_paid ? parseFloat(item.is_paid) : 0), 0);
        },
        totalAmount() {
            //  return 0;
            return (
                (this.totalMaleCount * this.maleRate) +
                (this.totalFemaleCount * this.femaleRate) + 
                (this.totalovertimeCount * this.overtimeRate) + 
                (parseFloat(this.total_gadibhade_amt)) 
            );
        },
        /*total_gadibhade_amt() {
            return ((this.totalMaleCount + this.totalFemaleCount) * this.gadiBhadeRate).toFixed(2);
    //   return this.filteredAttendanceList.map(item => {
    //     const presentDays = this.getPresentDaysInWeek(item);
    //     return {
    //       ...item,
    //       amount: this.calculateAmount(item.salary, presentDays).toFixed(2), // Calculate amount
    //       presentDays // Include present days for further use
    //     };
    //   });
    }*/
    },
    methods: {

        updateValue(event) {
    const newValue = event.target.value;
    // Optionally update something else if needed
  },

  formatDate(date) {
      const options = { day: '2-digit', month: '2-digit', year: '2-digit' };
      return new Date(date).toLocaleDateString('en-GB', options);
    },




      getEmployeeName(id) {
            const employee = this.employeeList.find(item => item.id === id);
            return employee ? employee.name : "";
        },


    // Method to filter attendances
    filterAttendances() {
      console.log('Filtering attendances from', this.startDate, 'to', this.endDate);
    },



        getPerformanceClass(performance) {
              if (performance == "3") return 'best';
              if (performance == "2") return 'good';
              return 'average'; 
            },


            exportToExcel() {
    // Select the datatable body rows
    const rows = Array.from(document.querySelectorAll("#basicDataTable tbody tr"));

    // Prepare headers from the table
    const headers = Array.from(
        document.querySelectorAll("#basicDataTable thead th")
    ).map(header => header.textContent.trim());

    // Prepare data rows from table
    const csvData = rows.map(row => {
        const cells = Array.from(row.querySelectorAll("td"));
        // Sanitize cell content to remove unwanted characters
        return cells.map(cell => cell.textContent.trim().replace(/[^ -~]/g, "") || "");
    });

    // Combine headers and rows
    const csvContent = [headers, ...csvData]
        .map(row => row.map(value => `"${value}"`).join(","))
        .join("\n");

    // Create a Blob for the CSV
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    // Trigger the download
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "attendance_report.csv");
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
},

 
 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },



        saveSalarySlip() {
        const salarySlipData = {
            parent_id: this.selectedEmployeeId,  
            from_date: this.startDate,  
            to_date: this.endDate,  
            total_male: this.totalMaleCount,  
            male_amt: this.totalMaleCount * this.maleRate,
            total_female: this.totalFemaleCount, 
            female_amt: this.totalFemaleCount * this.femaleRate,
            gadi_bhade: this.totalMaleCount + this.totalFemaleCount,
            gadi_rate: this.gadiBhadeRate,  
            amount: this.totalAmount,
            overtime: this.totalovertimeCount * this.overtimeRate
        }
        console.log(salarySlipData);
        axios.post('saveSalarySlip', salarySlipData)
            .then(response => {
                if(response.data.status == 'success')
                // var salary_id = response.data.salary_id;
                // this.savePresentEmployeesDetails(salary_id);
                this.$swal(response.data.message);
                // console.log(response.data);
            })
            .catch(error => {
                console.error('Error saving salary slip:', error);
            });
    },
    
          
        async getBasics() {
            var self = this;
            axios.post('getattendancereport').then(function (response) {
                self.empList = response.data.list;  // Store the full employee attendance list
                self.empParentList = response.data.emp_parent_list;  // Store the employee list for dropdown
                self.filteredAttendanceList = self.empList;   // Store the employee list for dropdown
                
             //   self.attendanceReport =  response.data.attendanceReport.att;  
               // self.original_attendanceReport=response.data.attendanceReport.att;
                
               // self.report_dates =  response.data.attendanceReport.dates; 
                
                
                self.startDate = response.data.fromdate;   
                self.endDate = response.data.todate; 
                
                
                self.totalMaleCount = response.data.attendanceReport.maleCounter; 
                self.totalFemaleCount = response.data.attendanceReport.femaleCounter; 
                self.employeeList = response.data.employeelist; 
                
                console.log(self.filteredAttendanceList);
            })
            .then(() => {
        
            });
        },


        printReceipt() {
      window.print();
    },



        async filter_dates() {
        // Check if an employee is selected
        if (!this.selectedEmployeeId) {
                        alert("Please select an employee first.");
                        return;
                    }

            var self = this;
            axios.post('getsingleattendancereport',{fromDate:this.startDate,toDate:this.endDate,emp_id: this.selectedEmployeeId}).then(function (response) {
                self.empList = response.data.list;  // Store the full employee attendance list
                self.empParentList = response.data.emp_parent_list;  // Store the employee list for dropdown
                self.filteredAttendanceList = self.empList;   // Store the employee list for dropdown
                 self.attendanceReport =  response.data.attendanceReport.att;   
                
                self.report_dates =  response.data.attendanceReport.dates; 
                
                
                self.startDate = response.data.fromdate;   
                self.endDate = response.data.todate; 
                
             
                self.totalMaleCount = response.data.attendanceReport.maleCounter; 
                self.totalFemaleCount = response.data.attendanceReport.femaleCounter; 
                
                  
            })
            .then(() => {
               
                
               
            });
        },
        
 
    }
}
</script>
//original attendance report